import { render, staticRenderFns } from "./ChangingPassword.vue?vue&type=template&id=10e31ce2"
import script from "./ChangingPassword.vue?vue&type=script&lang=js"
export * from "./ChangingPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports